// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"297":"606907b1","819":"4631f233"}[chunkId] + ".chunk.css";
};